"use client";

import { type CSSProperties, type ReactNode, useCallback, useRef } from "react";

import { useTranslations } from "next-intl";
import { heroFeatureChips } from "./hero-chip-defs";
import { HeroDemoCursor } from "./hero-demo-cursor";
import { Pill } from "./hero-primitives";
import type { HeroModuleKey } from "./hero-types";

export function HeroFeatureChipRow(props: {
  readonly active: HeroModuleKey;
  readonly setActive: (key: HeroModuleKey) => void;
  readonly style?: CSSProperties;
}): ReactNode {
  const tChips = useTranslations("marketing.heroChipDefs");
  const chipRowRef = useRef<HTMLDivElement | null>(null);

  const handleChipClick = useCallback(
    (key: HeroModuleKey): void => {
      props.setActive(key);
    },
    [props.setActive],
  );

  return (
    <div
      ref={chipRowRef}
      data-chips="1"
      style={{
        position: "relative",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        columnGap: 7,
        rowGap: 10,
        maxWidth: 1140,
        margin: "26px auto 0",
        overflow: "visible",
        ...props.style,
      }}
    >
      {heroFeatureChips(tChips).map((chip) => (
        <Pill
          key={chip.label}
          active={props.active === chip.key}
          onClick={() => {
            handleChipClick(chip.key);
          }}
        >
          {chip.label}
        </Pill>
      ))}
      <HeroDemoCursor rootRef={chipRowRef} />
    </div>
  );
}
